import { ref, deleteObject } from "firebase/storage";
import { storage } from "firebaseDb";

const deleteChemicalSds = async (chemicalKey = "") => {
  if (!chemicalKey) {
    return;
  }

  const fileRef = ref(storage, `chemicals/sds/${chemicalKey}`);
  try {
    await deleteObject(fileRef);
  } catch (error) {
    if (error?.code !== "storage/object-not-found") {
      throw error;
    }
  }
};

export default deleteChemicalSds;
